import {Matrix} from "./Matrix";

export class Camera{
    V;
    P;
    canvas;
    constructor(canvas:HTMLCanvasElement) {
        this.V = Matrix.identity(Matrix.create());
        this.P = Matrix.identity(Matrix.create());
        this.canvas = canvas;

    }
    LookAt(from:Array<number>,to:Array<number>,head:Array<number>=[0.0,1.0,0.0]){
        Matrix.lookAt(from, to, head, this.V);
        Matrix.perspective(90, this.canvas.width / this.canvas.height, 0.1, 100, this.P);
    }
}